<template>
    <div class="row" v-if="session && features.canNavigateInSession()">
        <div class="col-12 col-lg-8 mx-auto mt-3 mb-5">
            <div class="steps">
                <button class="steps-btn" :class="{
                        'highlighted': configurationHighlighted,
                        'enabled': configurationEnabled,
                        'current': current == 'configuration'
                    }"
                    @click="openConfiguration"
                    v-if="features.canOpenConfiguration()"
                >
                    <span>{{ $t('sessions.configuration') }}</span>
                </button>
                <button class="steps-btn" :class="{
                        'highlighted': observationHighlighted,
                        'enabled': observationEnabled,
                        'current': current == 'observation',
                        'notfirst': features.canOpenConfiguration()
                    }"
                    @click="openObservation"
                >
                    <span>{{ $t('sessions.observation') }}</span>
                </button>
                <button class="steps-btn notfirst" :class="{
                        'highlighted': evaluationHighlighted,
                        'enabled': evaluationEnabled,
                        'current': current == 'evaluation'
                    }"
                    @click="openEvaluation"
                >
                    <span>{{ $t('sessions.evaluation') }}</span>
                </button>
                <button class="steps-btn notfirst" :class="{
                        'highlighted': summaryHighlighted,
                        'enabled': summaryEnabled,
                        'current': current == 'summary'
                    }"
                    @click="openSummary"
                >
                    <span>{{ $t('sessions.summary') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import SessionFeatures from './SessionFeatures'

    export default {

        props: {
            session: {
                type: Object,
                required: true
            },

            current: {
                type: String,
                default: 'configuration'
            },
        },

        data() {
            return {
                features: new SessionFeatures(this.$router, this.$auth, this.session),
            }
        },

        computed: {
            
            // Enabled.

            configurationEnabled() {
                // Use this.session to keep the reactivity.
                return this.features.canOpenConfiguration(this.session) && this.current !== 'configuration'
            },

            observationEnabled() {
                // Use this.session to keep the reactivity.
                return this.features.canOpenObservation(this.session) && this.current !== 'observation'
            },
            
            evaluationEnabled() {
                // Use this.session to keep the reactivity.
                return this.features.canOpenEvaluation(this.session) && this.current !== 'evaluation'
            },
                        
            summaryEnabled() {
                // Use this.session to keep the reactivity.
                return this.features.canOpenSummary(this.session) && this.current !== 'summary'
            },

            // Highlighted.

            configurationHighlighted() {
                return true
            },

            observationHighlighted() {
                return this.current == 'observation' || this.current == 'evaluation' || this.current == 'summary'
            },
            
            evaluationHighlighted() {
                return this.current == 'evaluation' || this.current == 'summary'
            },
                        
            summaryHighlighted() {
                return this.current == 'summary'
            },
        },

        methods: {

            openConfiguration() {
                if (this.configurationEnabled) {
                    this.features.openConfiguration()
                }
            },
            
            openObservation() {
                if (this.observationEnabled) {
                    this.features.openObservation()
                }
            },
            
            openEvaluation() {
                if (this.evaluationEnabled) {
                    this.features.openEvaluation()
                }
            },
            
            openSummary() {
                if (this.summaryEnabled) {
                    this.features.openSummary()
                }
            },
        },
    }
</script>

<style lang="css" scoped>

    .steps {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    }

    .steps-btn {
        transition-property: all;
        transition-duration: .15s;
        transition-timing-function: linear;
        transition-delay: 0s;
        position: relative;
        padding-top: 20px;
        color: #dee2e6;
        border: none;
        background-color: transparent;
        outline: none !important;
        cursor: default;
    }

    .steps-btn.enabled {
        cursor: pointer;
    }

    .steps-btn.current {
        cursor: default;
    }

    .steps-btn.highlighted {
        color: #344767;
    }

    .steps-btn.highlighted span, .steps-btn.enabled span {
        color: #8392ab;
    }

    .steps-btn.current span {
        color: #344767;
    }

    .steps-btn:before {
        position: absolute;
        top: 0;
        left: 50%;
        display: block;
        width: 13px;
        height: 13px;
        content: "";
        transform: translateX(-50%);
        transition: all .15s linear 0s, transform .15s cubic-bezier(.05,1.09,.16,1.4) 0s;
        border: 2px solid currentColor;
        border-radius: 50%;
        background-color: #fff;
        box-sizing: border-box;
        z-index: 3;
    }

    .steps-btn.highlighted:before {
        transform: translateX(-50%) scale(1.2);
        background-color: currentColor;
    }

    .steps-btn.current:before {
        background-color: currentColor;
    }

    .steps-btn.notfirst:after {
        position: absolute;
        top: 5px;
        left: calc(-50% - 13px / 2);
        transition-property: all;
        transition-duration: .15s;
        transition-timing-function: linear;
        transition-delay: 0s;
        display: block;
        width: 100%;
        height: 2px;
        content: "";
        background-color: currentColor;
        z-index: 1;
    }

</style>